import React from 'react';
import { IconProps } from './types';

const Info: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 32 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M15.95 0c-8.8 0-15.95 7.15-15.95 16s7.15 16 15.95 16c8.85 0 16-7.15 16-16s-7.15-16-16-16v0zM19.3 24.8c-0.85 0.35-1.45 0.55-1.95 0.75s-1.050 0.25-1.7 0.25c-1 0-1.75-0.25-2.35-0.75-0.55-0.5-0.85-1.1-0.85-1.85 0-0.3 0.050-0.6 0.050-0.9 0.050-0.3 0.1-0.65 0.2-1l1.050-3.65c0.1-0.35 0.2-0.7 0.25-1 0.050-0.35 0.1-0.6 0.1-0.85 0-0.45-0.1-0.8-0.3-0.95-0.2-0.2-0.55-0.3-1.1-0.3-0.25 0-0.55 0.050-0.8 0.15-0.3 0.1-0.5 0.2-0.7 0.25l0.3-1.1c0.7-0.3 1.3-0.5 1.9-0.7s1.2-0.3 1.75-0.3c1 0 1.75 0.25 2.3 0.7 0.55 0.5 0.8 1.1 0.8 1.85 0 0.15-0.050 0.45-0.050 0.85-0.050 0.4-0.1 0.75-0.2 1.1l-1 3.6c-0.1 0.3-0.15 0.65-0.25 1-0.1 0.4-0.1 0.65-0.1 0.85 0 0.5 0.1 0.8 0.35 1s0.6 0.25 1.1 0.25c0.25 0 0.55-0.050 0.85-0.15s0.55-0.15 0.7-0.25l-0.35 1.15zM19.15 10.1c-0.5 0.45-1.050 0.65-1.7 0.65s-1.25-0.25-1.7-0.65c-0.5-0.45-0.7-1-0.7-1.6s0.25-1.15 0.7-1.6c0.5-0.45 1.050-0.65 1.7-0.65 0.7 0 1.25 0.25 1.7 0.65 0.5 0.45 0.7 1 0.7 1.6s-0.25 1.1-0.7 1.6v0z"
    />
  </svg>
);

export default Info;
